import { Checkbox } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { useJWT } from '@/hooks/useJWT.hook';
import { ToastTypesEnum, useToast } from '@/hooks/useToast';

import { tKeys } from '@/i18n/resourses';

import { useUpdateUserDataSubscriptionMutation } from '@/services/api.service';

import { useAuthStore } from '@/store/hooks/useAuthStore';

export const MarketingCheckbox = () => {
  const { t } = useTranslation();

  const { jwt } = useJWT();

  const toast = useToast();
  const [triggerApi, { isLoading }] = useUpdateUserDataSubscriptionMutation();
  const { allow_marketing_notifications, setAllowMarketingNotification } =
    useAuthStore();

  const checkboxHandler = async (marketing_notifications_allow: boolean) => {
    try {
      await triggerApi({
        marketing_notifications_allow,
        token: jwt,
      });
      setAllowMarketingNotification(marketing_notifications_allow);
    } catch (error) {
      toast(t(tKeys.oops), ToastTypesEnum.error);
    }
  };

  return (
    <Checkbox
      checked={allow_marketing_notifications}
      disabled={isLoading}
      name="allow_marketing_notifications"
      onChange={(event) => checkboxHandler(event.target.checked)}
    >
      {t(tKeys.marketingConsentSidebar)}
    </Checkbox>
  );
};
